// A REAKCIÓ-TOGGLE OPTIMISTA SZABÁLYA — tiszta függvény, React és cache-alak nélkül.
//
// MIÉRT KÜLÖN FÁJL: ugyanezt a szabályt KÉT felület használja — a belső jegy-szál (`ticket-comments.tsx`,
// lista-válasz) és a partner-portál jegy-részlete (`portal.tickets.$id.tsx`, részlet-válasz). A CACHE ALAKJA
// más (tömb vs. beágyazott `comments`), a SZABÁLY viszont egy: a saját reakció be/ki, a darabszám ±1, és a
// nullára futó emoji-csoport eltűnik. Két példányban ez a két felületen csendben eltérő optimista viselkedést
// adott volna (pl. az egyik ott hagyja a 0-s chipet).

/** Egy reagáló a felugró listában — a NÉV-RÉSZEK a nyelv-függő sorrendhez. */
export interface ReactionActorLike {
  /** A belső azonosító — a PARTNER-válaszban nincs (ezért opcionális); a felismerés az `isMe`-n megy. */
  identityId?: string | undefined;
  /** A HÍVÓ saját reakciója-e. A szerver tölti ki — a kliens nem hasonlít azonosítót. */
  isMe: boolean;
  name: string | null;
  givenName: string | null;
  familyName: string | null;
  avatarUrl?: string | null | undefined;
  teamColor?: string | null | undefined;
}

/** Egy emoji összesítése egy kommenten. */
export interface ReactionLike {
  emoji: string;
  count: number;
  reactedByMe: boolean;
  actors: ReactionActorLike[];
}

/**
 * Egy komment reakció-listája a toggle UTÁNI állapotban — pontosan úgy, ahogy a szerver is számolja.
 *
 * A HOZZÁADOTT aktor NÉV NÉLKÜL kerül be (`null` részek): a felület a saját nevét itt nem tudja, és nem is
 * kell — a `onSettled` invalidálás után a szerver dúsított listája jön. Addig a felugró listában a monogram-
 * fallback áll, ami rosszabb lenne, mint egy HAMIS név.
 */
export function toggleReactionList(
  // A `reactions` a szerződésben kötelező, de egy RÉGI (cache-elt / még nem újraindult BFF-től jött) sor nem
  // hordozza — a toggle ilyenkor sem dobhat.
  current: readonly ReactionLike[] | undefined,
  emoji: string,
): ReactionLike[] {
  const list = current ?? [];
  const existing = list.find((r) => r.emoji === emoji);
  if (existing?.reactedByMe) {
    // LEVÉTEL: a darabszám csökken, és ha nullára fut, az emoji-csoport eltűnik.
    return list
      .map((r) =>
        r.emoji === emoji
          ? {
              ...r,
              count: r.count - 1,
              reactedByMe: false,
              actors: r.actors.filter((a) => !a.isMe),
            }
          : r,
      )
      .filter((r) => r.count > 0);
  }
  // HOZZÁADÁS: meglévő csoport növelése, vagy új csoport a sáv VÉGÉRE (a szerver majd rendezi).
  const me: ReactionActorLike = {
    isMe: true,
    name: null,
    givenName: null,
    familyName: null,
    avatarUrl: null,
    teamColor: null,
  };
  return existing === undefined
    ? [...list, { emoji, count: 1, reactedByMe: true, actors: [me] }]
    : list.map((r) =>
        r.emoji === emoji
          ? { ...r, count: r.count + 1, reactedByMe: true, actors: [...r.actors, me] }
          : r,
      );
}
